/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  const KEY_ESCAPE = 'Escape';

  const _mediaQueryIsMobile = window.matchMedia('(max-width: 1199.98px)');
  const _mainNav = document.querySelector('[data-main-nav]');
  const _megaMenu = document.querySelector('[data-mega-menu]');
  const _megaMenuTriggers = document.querySelectorAll('[data-mega-menu-trigger]');
  const _megaMenuContainers = document.querySelectorAll('[data-mega-menu-container]');
  let _clickedTrigger = null;
  let _openMenuId = null;

  function init() {
    initStickyNav();
    initMegaMenu();
    initLangSwitch();
  }

  //
  // Sticky navigation
  //

  function initStickyNav() {
    window.addEventListener('scroll', () => {
      // Using requestAnimationFrame inside the scroll event prevents
      // performance issues caused by excessive event firing.
      requestAnimationFrame(() => {
        var offset = _mediaQueryIsMobile.matches ? 0 : 50;
        _mainNav.dataset.sticky = window.scrollY >= offset;
      });
    });
  }

  //
  // Mega menu
  //

  function openMegaMenu(container, trigger) {
    container.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', true);
    trigger.setAttribute('aria-label', trigger.dataset.closeText);
  }

  function closeMegaMenu(container, trigger) {
    container.setAttribute('hidden', 'hidden');
    trigger.setAttribute('aria-expanded', false);
    trigger.setAttribute('aria-label', trigger.dataset.openText);
  }

  function closeAllMegaMenus() {
    // Close all mega menus
    _megaMenuContainers.forEach((container) => {
      container.setAttribute('hidden', 'hidden');
    });

    // Reset all triggers
    _megaMenuTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', false);
      trigger.setAttribute('aria-label', trigger.dataset.closeText);
    });

    // Switch focus back to the clicked trigger
    if (_clickedTrigger) {
      _clickedTrigger.focus();
      _clickedTrigger = null;
    }

    _openMenuId = null;
  }

  function triggerClickHandler(event) {
    event.preventDefault();

    // Get the ID of the clicked trigger
    const menuId = event.target.getAttribute('aria-controls');

    // Close all other mega menus
    if (_openMenuId && _openMenuId !== menuId) closeAllMegaMenus();

    // Store the clicked trigger to focus on it later
    _clickedTrigger = util.isKeyboardEvent(event) ? event.target : null;

    // Find the corresponding container
    const container = Array.from(_megaMenuContainers).find((container) => {
      return container.id === menuId;
    });

    if (!container) return;

    // Toggle the mega menu based on its current state
    if (event.target.getAttribute('aria-expanded') === 'true') {
      closeMegaMenu(container, event.target);
      _openMenuId = null;
    } else {
      openMegaMenu(container, event.target);
      _openMenuId = menuId;

      // DATALAYER
      app.dataLayer.pushEvent('primaireNavClick', {
        pageUrl: window.location.pathname,
        destinationUrl: 'Open menu: ' + event.target.dataset.title,
      });
    }
  }

  function keyboardHandler(event) {
    if (event.code === KEY_ESCAPE) {
      closeAllMegaMenus();
    }
  }

  function initMegaMenu() {
    if (!_megaMenu) return;

    // Add event listeners to mega menu triggers
    _megaMenuTriggers.forEach((trigger) => {
      trigger.addEventListener('click', triggerClickHandler);
    });

    // Add event listeners to the mega menu (ESC key)
    _megaMenu.addEventListener('keydown', keyboardHandler);

    // Close mega menu when clicking outside
    document.addEventListener('click', (event) => {
      if (util.getAncestorClassNames(event.target).includes('navMain') === false) {
        closeAllMegaMenus();
      }
    });
  }

  //
  // Handle submenus on window resize
  // Close all submenus on mobile
  //

  function onWindowResize() {
    if (_mediaQueryIsMobile.matches) {
      closeAllMegaMenus();
    }
  }

  _mediaQueryIsMobile.addEventListener('change', onWindowResize);
  onWindowResize();

  //
  // Language switch
  //

  const _langTrigger = document.querySelector('[data-lang-switch-trigger]');
  const _langClose = document.querySelector('[data-lang-switch-close]');
  const _langContainer = document.querySelector('[data-lang-switch-container]');

  function initLangSwitch() {
    if (!_langTrigger || !_langContainer) return;

    _langTrigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (_langTrigger.getAttribute('aria-expanded') === 'false') {
        openLangSwitch();
      } else {
        closeLangSwitch(false);
      }
    });

    _langClose.addEventListener('click', (event) => {
      event.preventDefault();
      closeLangSwitch(false);
    });

    document.addEventListener('click', (event) => {
      const classNames = event.target.getAttribute('class');

      if (classNames !== null && classNames.indexOf('langSwitch') === -1) {
        closeLangSwitch(false);
      }
    });

    _langContainer.addEventListener('keydown', (event) => {
      if (event.code === KEY_ESCAPE) {
        closeLangSwitch(true);
      }
    });
  }

  function openLangSwitch() {
    _langContainer.classList.add('is-open');
    _langContainer.style.visibility = 'visible';

    // a11y: update aria attributes
    _langTrigger.setAttribute('aria-label', _langTrigger.dataset.closeText);
    _langTrigger.setAttribute('aria-expanded', true);
  }

  function closeLangSwitch(setFocus) {
    setFocus = setFocus || false;
    _langContainer.classList.remove('is-open');

    // a11y: switch focus back to trigger
    if (setFocus) _langTrigger.focus();

    // a11y: update aria attributes
    _langTrigger.setAttribute('aria-label', _langTrigger.dataset.openText);
    _langTrigger.setAttribute('aria-expanded', false);

    window.setTimeout(() => {
      _langContainer.style.visibility = 'hidden';
    }, 500);
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
